module.exports = __webpack_public_path__ + "img/retrospect-16-mobile.748a73a9.jpg";